/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-08-24T17:05:26.905
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHouseLockLog,
	listRentHouseLockLogInit,
	listRentHouseLockLogByAuthorizations,
	deleteRentHouseLockLog
	
} from '@api/rentmanage/RentHouseLockLog';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHouseLockLog({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseLockLog(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseLockLogByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseLockLogByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseLockLogInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseLockLogInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseLockLog({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseLockLog({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
